import RequestInstance from './instance'

export function createInstance(config = {}) {
  return new RequestInstance(config)
}
